var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vb-toggle"},[_c('vb-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.id),expression:"id"}],staticClass:"vb-toggle__btn",attrs:{"vb_options":{
        text: _vm.btn_text,
        variant: _vm.btn_variant,
        pill: true,
        block: true,
      }}}),_c('b-collapse',{staticClass:"vb-toggle__collapse",attrs:{"id":_vm.id,"accordion":_vm.accordion,"appear":_vm.appear,"is-nav":_vm.is_nav,"tag":_vm.tag},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }